import { useAccount } from '@feathr/report_components';

export interface IUseFeatureLimitsReturn {
  isContactLimitsEnabled: boolean;
  isEmailLimitsEnabled: boolean;
}

/**
 * Hook that wraps useContactLimits and useEmailLimits flags with additional checks
 * for num_identified_persons and num_monthly_emails having values respectively.
 * This replaces the individual isContactLimitsEnabled and isEmailLimitsEnabled conditions.
 */
function useFeatureLimits(): IUseFeatureLimitsReturn {
  const account = useAccount();

  // Check if contact limits feature is enabled AND has a valid num_identified_persons value
  const isContactLimitsEnabled = Boolean(account?.activePackage?.num_identified_persons);

  // Check if email limits feature is enabled AND has a valid num_monthly_emails value
  const isEmailLimitsEnabled = Boolean(account?.activePackage?.num_monthly_emails);

  return {
    isContactLimitsEnabled,
    isEmailLimitsEnabled,
  };
}

export default useFeatureLimits;
